<template>
  <footer class="the-footer footer text-center">
    &copy; 2019-{{ currentYear }} Heavybit, Inc. Internal use only.
  </footer>
</template>

<script setup lang="ts">
import { computed } from "vue"

const currentYear = computed(() => new Date().getFullYear())
</script>

<style>
.the-footer {
  box-shadow: 0 50vh 0 50vh var(--auger-bg-subtle);

  @media (max-width: 768px) {
    display: none;
  }
}
</style>
